export default __webpack_public_path__ + "static/media/noInternet.30016990.svg";